<template>
    <div class="HeaderTitle">
        <div class="left">
            <span class="text">{{titleName}}</span>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name:'HeaderTitle',
    data() {
        return {
            titleName:''
        }
    },

    watch:{
        $route:{
            handler() {
                this.titleName = this.$route.meta.name
            },
            immediate: true
        },
    }
}
</script>

<style lang="scss" scoped>
    .HeaderTitle{
        width: 100%;
        height: 50px;
        // border-bottom:1px solid  #F2F2F2;
        border-bottom: 1px solid  #eaeaea;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left{
            .text{
                font-size: 18px;
                // color: #2A2A2A;
                line-height: 50px;
                font-family: Microsoft YaHei;
                color: #333333;
            }
        }
        
    }

</style>